import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipDirective } from '@kaseya-design-components';

@Component({
  selector: 'itc-managers-button',
  templateUrl: 'managers-button.component.html',
  styleUrl: 'managers-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [TooltipDirective, TranslatePipe],
})
export class ManagersButtonComponent {}
